import { Driver } from "@lib/types/driver";
import { DriverGroup } from "@lib/types/driver_group";
import { UnitGroup } from "@lib/types/unit_group";

export enum BindingType {
  RECURRING = "recurring",
  EXPIRING = "expiring",
  ONE_TIME = "one_time",
}

export enum RecurringType {
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
}

export type Schedules = {
  id: string;
  start_time: string;
  end_time: string;
  day_of_month: number;
  days_of_week: number[];
  recurring_type: RecurringType;
  created_at: string;
  updated_at: string | null;
};

export type Unit = {
  cls: string;
  name: string;
  unit_id: number;
};

export type Binding = {
  id: string;
  unit_id: number | null;
  unit_details: Unit | null;
  unit_group_id: number | null;
  unit_group_details: UnitGroup | null;
  user_id: string;
  binding_type: BindingType;
  driver_id: string | null;
  driver_details: Driver | null;
  driver_group_id: number | null;
  driver_group_details: DriverGroup | null;
  parameter_number: number | null;
  start_datetime: string | null;
  end_datetime: string | null;
  status: string;
  schedules: Schedules[];
  timezone: string;
  created_at: string;
  updated_at: string | null;
};

export type BindingsList = {
  bindings: Binding[];
};

export type BindingResponse = {
  binding: Binding;
};

export interface DeleteBindingResponse {
  message: string;
}
